// extracted by mini-css-extract-plugin
export default {"root":"SpecInfoAbout_root__HEg8u","required_asterisk":"SpecInfoAbout_required_asterisk__AgV-t","row":"SpecInfoAbout_row__u5aUA","error":"SpecInfoAbout_error__rRboj"};